<template>
  <div class="home-container">
    <div class="page-head">
      <div class="head-left">
        <h2 class="title">
          {{ headTitle }}
        </h2>
        <span class="count">{{ shownList.length }} 个站点</span>
      </div>

      <el-input
        v-model.trim="keyword"
        class="search-input"
        placeholder="搜索站点名称 / 域名"
        prefix-icon="el-icon-search"
        clearable
      />
    </div>

    <div
      :key="gridKey"
      class="grid-wrap"
    >
      <div
        v-if="shownList.length"
        class="card-grid"
      >
        <nav-card
          v-for="(item, index) in shownList"
          :key="item.name + index"
          :data="item"
        />
      </div>
      <div
        v-else
        class="empty-tip"
      >
        <i class="el-icon-search" />
        <p>没有找到匹配的站点</p>
      </div>
    </div>
  </div>
</template>

<script>
  import NavCard from '@/components/NavCard/NavCard.vue'
  import { mapState } from 'vuex'

  export default {
    components: { NavCard },
    data() {
      return {
        keyword: '',
        categories: urlData.filter((item) => !item.hide),
      }
    },
    computed: {
      ...mapState(['currentClass']),
      current() {
        return this.categories[this.currentClass] || this.categories[0]
      },
      shownList() {
        if (!this.keyword) return this.current.list

        const kw = this.keyword.toLowerCase()
        return this.categories
          .flatMap((item) => item.list)
          .filter(
            (item) =>
              (item.name || '').toLowerCase().includes(kw) ||
              (item.description || '').toLowerCase().includes(kw) ||
              (item.url || '').toLowerCase().includes(kw)
          )
      },
      headTitle() {
        return this.keyword ? `搜索“${this.keyword}”` : this.current.className
      },
      gridKey() {
        return this.keyword ? 'search' : this.currentClass
      },
    },
  }
</script>

<style lang="scss" scoped>
  .page-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 24px;

    .head-left {
      display: flex;
      align-items: baseline;
      gap: 12px;

      .title {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        color: #f0f3f8;
      }

      .count {
        font-size: 13px;
        color: #6f7a8d;
      }
    }

    .search-input {
      width: 260px;
    }
  }

  .grid-wrap {
    animation: fade-up 0.35s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  @keyframes fade-up {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
  }

  .card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }

  .empty-tip {
    padding: 80px 0;
    text-align: center;
    color: #6f7a8d;

    i {
      font-size: 42px;
    }

    p {
      margin-top: 14px;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 640px) {
    .page-head .search-input {
      width: 100%;
    }

    .card-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
